import jsPDF from "jspdf";
import "jspdf-autotable";
import { format } from "date-fns";
const dateFormat = "dd-MM-yyyy";

const downloadPdfStatement = async (member) => {
    const memberInfo = member?.member
    const payments = member?.payments
    const ledger = member?.ledger

    let totalPayments = 0;
    payments?.map(paymt => 
        totalPayments += paymt.payment_amount
    )
    
    const doc = new jsPDF({
        orientation: 'portrait',
        // unit: 'px',
        format: 'a4'
    })

    // var doc = new jsPDF();
    var img = new Image();
    img.src = '/images/logos/proforum_main.jpg';
    
    let curr = new Date();
    curr.setDate(curr.getDate());
    // let currentDate = curr.toISOString().substring(0, 10);
    let currentDate = format(new Date(), dateFormat)
   
    doc.setTextColor('black');
    doc.setFontSize('7');
    doc.text(150, 12, "DATE PRINTED :");
    doc.text(170, 12, currentDate);
    doc.addImage(img, 'JPEG', 90, 15, 25, 25);
    doc.addFont('helvetica', 'normal');
    doc.setTextColor('brown');
    doc.setFontSize('14');
    doc.setFont('', '', 'bold');
    doc.text(65, 50, "NDC PROFESSIONALS FORUM");

    doc.setTextColor('green');
    doc.setFontSize('12');
    doc.text(80, 55, "MEMBER STATEMENT");
    doc.setTextColor('brown');
    doc.setFontSize('12');
    doc.text(15, 70, 'MEMBER INFORMATION');

    doc.setTextColor('black');
    doc.setFontSize('10');
    doc.text(15, 80, 'FULL NAME');
    doc.text(15, 85, 'PF NUMBER');
    doc.text(15, 90, 'MOBILE NUMBER');
    doc.text(15, 95, 'EMAIL');
    doc.text(15, 100, 'REGION');

    doc.text(110, 80, 'DATE JOINED');
    doc.text(110, 85, 'VOTER ID');
    doc.text(110, 90, 'GENDER');
    doc.text(110, 95, 'PROFESSION');
    doc.text(110, 100, 'CONSTITUENCY');

    doc.setFont('', '', 'normal');
    doc.setFontSize('8');
    doc.text(50, 80, memberInfo?.first_name + " " + memberInfo?.middle_name + " " + memberInfo?.last_name)
    doc.text(50, 85, memberInfo?.pf_number);
    doc.text(50, 90, memberInfo?.mobile_number);
    doc.text(50, 95, memberInfo?.email);
    doc.text(50, 100, memberInfo?.region);

    doc.text(145, 80, format(new Date(memberInfo?.date_joined), dateFormat));
    doc.text(145, 85, memberInfo?.voter_id_number);
    doc.text(145, 90, memberInfo?.gender.toUpperCase());
    doc.text(145, 95, memberInfo?.profession);
    doc.text(145, 100, memberInfo?.constituency);

    doc.setFont('', '', 'bold');
    doc.setTextColor('brown');
    doc.setFontSize('12');
    doc.text(15, 110, 'PAYMENT TRANSACTIONS');

    var totalPagesExp = '{total_pages_count_string}'

    var paymtHead = paymentHeader()
    var paymtBody = paymentBody(payments)
    var paymtFoot = paymentFooter(totalPayments)

    var ledgHead = ledgerHeader()
    var ledgBody = ledgerBody(ledger)



    // PAYMENT TABLE
    doc.autoTable({
        head: paymtHead,
        body: paymtBody,
        foot: paymtFoot,
        didDrawPage: function (data) {
            // Footer
            var str = 'Page ' + doc.internal.getNumberOfPages()
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(8)

            // jsPDF 1.4+ uses getHeight, <1.4 uses .height
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        margin: { top: 30 },
        startY: 115,
        theme: 'grid',
        footStyles: {
            fillColor: [0, 128, 0],
            textColor: [255, 255, 255],
            fontSize: 9,
            halign: 'right',
            columnStyles: {
                0: {
                    halign: 'left',
                    tableWidth: 100,
                },
            }
        },
        columnStyles: {
            0: {
                halign: 'center',
                tableWidth: 100,
            },
            1: {
                halign: 'center',
                tableWidth: 100,
            },
            2: { halign: 'left' },
            3: { halign: 'left' },
            4: { halign: 'left' },
            5: {
                halign: 'right',
                tableWidth: 100,
            },
        },
        headStyles: {
            fillColor: [0, 128, 0],
            fontSize: 9,
        },
        styles: {
            cellPadding: 1.5,
            fontSize: 8,
        },
    })


    // LEDGER TABLE
    doc.text(15, doc.lastAutoTable.finalY + 10, 'LEDGER ACCOUNT');
    doc.autoTable({
        head: ledgHead,
        body: ledgBody,
        didDrawPage: function (data) {
            // Footer
            var str = 'Page ' + doc.internal.getNumberOfPages()
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(8)

            // jsPDF 1.4+ uses getHeight, <1.4 uses .height
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        margin: { top: 30 },
        // startY: 165,
        startY: doc.lastAutoTable.finalY + 14,
        theme: 'grid',
        styles: {
            cellPadding: 1.5,
            fontSize: 8,
            halign: 'right',
        },
        columnStyles: {
            0: {
                halign: 'center',
                tableWidth: 100,
            },
            1: {
                halign: 'right',
                tableWidth: 100,
            },
            2: {
                halign: 'right',
                tableWidth: 100,
            },
            3: {
                halign: 'right',
                tableWidth: 100,
            },
            4: {
                halign: 'right',
                tableWidth: 100,
            },
        },
        headStyles: {
            fillColor: [0, 128, 0],
            fontSize: 9,
        },
    })


    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
    }
    doc.setTextColor('black');
    doc.setFontSize('10');
    doc.setFont('', '', 'normal');
    var pageSize = doc.internal.pageSize
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
    var text = doc.splitTextToSize("NOTE: This statement shows member payment transactions from the date member joined NDC Professionals Forum. For further information, contact PROFORUM National Office", pageWidth - 35, {})

    doc.text(text,
        15, doc.lastAutoTable.finalY + 10
    )
    const date = Date().split(" ");
    const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];
    doc.save(`${dateStr}.pdf`);
}

export default downloadPdfStatement;

/*
 |--------------------------------------------------------------------------
 | Below is some helper functions for the PDF Services
 |--------------------------------------------------------------------------
 */

function paymentHeader() {
    return [
        {
            year: "Year",
            payment_date: "Payment Date",
            receipt_number: "Receipt Number",
            payment_type: "Payment Type",
            description: "Description",
            payment_amount: "Payment Amount"
        },
    ]
}
function paymentFooter(totPayments) {
    return [
        {
            year: {
                content: 'Total Payment Transactions',
                colSpan: 5,
                styles: { halign: 'left' },
            },
            payment_amount: totPayments.toLocaleString(undefined, { minimumFractionDigits: 2 })
        },
    ]
}

function ledgerHeader() {
    return [
        {
            year: "Year",
            opening_balance: "Opening Balance",
            expected_total_amount: "Expected Amount",
            total_amount_paid: "Amount Paid",
            closing_balance: "Closing Balance",
        },
    ]
}


function paymentBody(payments) {
    var payData = payments
    var body = []
    let paymtAmount = 0
    let describePayment = ""
    for (var j = 0; j < payData.length; j++) {
        paymtAmount = payData[j].payment_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })
        describePayment = payData[j].description.toUpperCase()
        body.push({
            year: payData[j].year,
            payment_date: format(new Date(payData[j].payment_date), dateFormat),
            receipt_number: payData[j].receipt_number,
            payment_type: payData[j].payment_type,
            description: describePayment,
            payment_amount: paymtAmount
        })
    }
    return body
}

function ledgerBody(ledger) {
    var ledgerData = ledger
    var body = []
    let openingBalance = 0
    let expectedAmount = 0
    let amountPaid = 0
    let closingBalance = 0

    for (var i = 0; i < ledgerData.length; i++) {
        if (ledgerData[i].opening_balance < 0) {
            openingBalance = "(" + (ledgerData[i].opening_balance * -1).toLocaleString(undefined, { minimumFractionDigits: 2 }) + ")";
        } else {
            openingBalance = ledgerData[i].opening_balance.toLocaleString(undefined, { minimumFractionDigits: 2 })
        }
        if (ledgerData[i].expected_total_amount < 0) {
            expectedAmount = "(" + (ledgerData[i].expected_total_amount * -1).toLocaleString(undefined, { minimumFractionDigits: 2 }) + ")"
        } else {
            expectedAmount = ledgerData[i].expected_total_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })
        }
        if (ledgerData[i].total_amount_paid < 0) {
            amountPaid = "(" + (ledgerData[i].total_amount_paid * -1).toLocaleString(undefined, { minimumFractionDigits: 2 }) + ")"
        } else {
            amountPaid = ledgerData[i].total_amount_paid.toLocaleString(undefined, { minimumFractionDigits: 2 })
        }
        if (ledgerData[i].closing_balance < 0) {
            closingBalance = "(" + (ledgerData[i].closing_balance * -1).toLocaleString(undefined, { minimumFractionDigits: 2 }) + ")"
        } else {
            closingBalance = ledgerData[i].closing_balance.toLocaleString(undefined, { minimumFractionDigits: 2 })
        }

        body.push({
            year: ledgerData[i].year,
            opening_balance: openingBalance,
            expected_total_amount: expectedAmount,
            total_amount_paid: amountPaid,
            closing_balance: closingBalance,
        })
    }

    return body
}
